import { render, staticRenderFns } from "./BackGround.vue?vue&type=template&id=6f0d0635&scoped=true"
import script from "./BackGround.vue?vue&type=script&lang=js"
export * from "./BackGround.vue?vue&type=script&lang=js"
import style0 from "./BackGround.vue?vue&type=style&index=0&id=6f0d0635&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0d0635",
  null
  
)

export default component.exports